var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"title_text",attrs:{"id":_vm.$attrs['title-id']}},[_vm._v(_vm._s(_vm.$props.title))]),_vm._t("title")],2),_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }